/**
 * The keys of the --space-* scale in tokens.css. Stack and Inline take one of
 * these for their `gap` prop and turn it into `var(--space-N)`, so a gap can
 * never be a value the token scale doesn't define.
 */
export type SpaceToken = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 10 | 12 | 16;

export function spaceVar(token: SpaceToken): string {
  return `var(--space-${token})`;
}
